import functions from "./functions";

let checkAllToggles;

function selectAllCheckbox(){

    checkAllToggles.forEach((input) => {
        checkAll.checked ? input.checked = true : input.checked = false;
        let newsletterItemsContainer = document.querySelector('[data-register-newsletter]');
        if (checkAll.checked) {
            newsletterItemsContainer.classList.add('show-animals');
        } else {
            newsletterItemsContainer.classList.remove('show-animals');
        }
    });
}

let checkAll;
let checkCount = 0;

function init(){

    if (functions.checkPage('my-account')
        || functions.checkPage('registration')) {

        checkAll = document.querySelector('[data-account-checkbox-all]');
        checkAllToggles = document.querySelectorAll('[data-account-checkbox-toggle]');
        if (checkAll && checkAllToggles) {
            checkAllToggles.forEach((input) => {
                input.checked ? checkCount++ : null;
                checkCount === checkAllToggles.length ? checkAll.checked = true : null;

            });
            checkAll.addEventListener('change', selectAllCheckbox);
        }
    }

    if (functions.checkPage('my-account')) {

        if (window.innerWidth <= functions.breakpoints.sm) {
            $('.my-account-navi').addClass('mobile');
            $('[data-navigation-output]').addClass('hidden');
            $('[data-navigation-backward]').on('click', function (){
                $('[data-navigation-output]').addClass('hidden');
                $('.my-account-navi').toggleClass('visible');
                $(this).addClass('hidden');
            });

            $('.my-account-navi ul li a').each(function (index, item){
                if (window.location.href === $(item).attr('href')) {
                    $('.my-account-navi').removeClass('visible');
                    $('[data-navigation-output]').removeClass('hidden');
                    $('[data-navigation-backward]').removeClass('hidden');
                }
            });

            $('.my-account-navi.mobile li a').on('click', function (e){
                if ($(this).parent().hasClass('is-active')) {
                    e.preventDefault();

                    $('.my-account-navi').removeClass('visible');
                    $('[data-navigation-output]').removeClass('hidden');
                    $('[data-navigation-backward]').removeClass('hidden');
                }
            });

            if ( window.location.href===window.location.origin + '/moje-konto/' ){
                $('.my-account-navi').addClass('visible');
                $('[data-navigation-output]').addClass('hidden');
                $('[data-navigation-backward]').addClass('hidden');

                if(document.referrer.includes('/moje-konto/') && document.referrer.split('/moje-konto/')[1] !== '') {
                    $('.my-account-navi').removeClass('visible');
                    $('[data-navigation-output]').removeClass('hidden');
                    $('[data-navigation-backward]').removeClass('hidden');
                }
            } else {
                $('.my-account-navi').removeClass('visible');
                $('[data-navigation-output]').removeClass('hidden');
                $('[data-navigation-backward]').removeClass('hidden');
            }
        }
    }
}

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/my-account.js